// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"01b680e9","703":"c11e140c"}[chunkId] + ".chunk.js";
};